import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlasfaserVfpDomain = state => state.GLASFASERVFP || initialState;

const selectLoading = () =>
    createSelector(selectGlasfaserVfpDomain, state => state.loading);

const selectError = () =>
    createSelector(selectGlasfaserVfpDomain, state => state.error);

const selectAddressFailed = () =>
    createSelector(selectGlasfaserVfpDomain, state => state.addressNotFound);

const selectInitAddressForm = () =>
    createSelector(selectGlasfaserVfpDomain, state => state.initAddressForm);

const selectFormData = () =>
    createSelector(selectGlasfaserVfpDomain, state => state.formData);

const selectorResponseData = () =>
    createSelector(selectGlasfaserVfpDomain, state => state.responseData);

export {
        selectLoading,
        selectError,
        selectAddressFailed,
        selectInitAddressForm,
        selectFormData,
        selectorResponseData,
    };
